import { compact, map } from 'es-toolkit/compat';
import { Message, MessageMedia } from '@/models';

const MIME_TYPES = (mime: string) => {
  if (mime && mime.indexOf('/') > -1) {
    return mime.split('/')[0];
  }

  return undefined;
};

function media(data: MessageMedia): MessageMedia | undefined {
  if (data && data.type) {
    return {
      mimeType: data.type,
      type: MIME_TYPES(data.type),
      url: data.url,
    };
  }
  return undefined;
}

export const transformMessage = (message: Message): Message => {
  return {
    ...message,
    from_name: message.from_name || message.name,
    parsedMedia: compact(map(message.media, (file) => media(file))),
  };
};
